export default __webpack_public_path__ + "static/media/flat-cube.cb953ebf.svg";